import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartSummaryCardComponent } from './cart-summary-card.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecommendationsModule } from '../../recommendations/recommendations.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CartSummaryCardComponent],
  exports: [
    CartSummaryCardComponent
  ],
  imports: [
    CommonModule,
    RecommendationsModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    RouterModule
  ]
})
export class CartSummaryCardModule { }
